// This file is auto-generated by @hey-api/openapi-ts

import * as v from "valibot";

export const vSiteConfig = v.object({
  server_name: v.string(),
  password_login_enabled: v.optional(v.boolean()),
  password_registration_enabled: v.optional(v.boolean()),
  password_registration_email_required: v.optional(v.boolean()),
  password_registration_token_required: v.optional(v.boolean()),
  registration_token_required: v.optional(v.boolean()),
  email_change_allowed: v.optional(v.boolean()),
  displayname_change_allowed: v.optional(v.boolean()),
  password_change_allowed: v.optional(v.boolean()),
  account_recovery_allowed: v.optional(v.boolean()),
  account_deactivation_allowed: v.optional(v.boolean()),
  captcha_enabled: v.optional(v.boolean()),
  minimum_password_complexity: v.optional(
    v.pipe(v.number(), v.integer(), v.minValue(0), v.maxValue(4)),
  ),
});

export const vVersion = v.object({
  version: v.string(),
});

/**
 * ULID
 *
 * A ULID as per https://github.com/ulid/spec
 */
export const vUlid = v.pipe(
  v.string(),
  v.regex(/^[0123456789ABCDEFGHJKMNPQRSTVWXYZ]{26}$/),
);

export const vIncludeCount = v.union([
  v.picklist(["true"]),
  v.picklist(["false"]),
  v.picklist(["only"]),
]);

export const vPaginationParams = v.object({
  "page[before]": v.nullish(vUlid),
  "page[after]": v.nullish(vUlid),
  "page[first]": v.nullish(v.pipe(v.number(), v.integer(), v.minValue(1))),
  "page[last]": v.nullish(v.pipe(v.number(), v.integer(), v.minValue(1))),
  count: v.nullish(vIncludeCount),
});

export const vCompatSessionStatus = v.picklist(["active", "finished"]);

export const vCompatSessionFilter = v.object({
  "filter[user]": v.nullish(vUlid),
  "filter[user-session]": v.nullish(vUlid),
  "filter[status]": v.nullish(vCompatSessionStatus),
  "filter[created-before]": v.nullish(v.pipe(v.string(), v.isoTimestamp())),
  "filter[created-after]": v.nullish(v.pipe(v.string(), v.isoTimestamp())),
  "filter[last-active-before]": v.nullish(v.pipe(v.string(), v.isoTimestamp())),
  "filter[last-active-after]": v.nullish(v.pipe(v.string(), v.isoTimestamp())),
});

export const vPaginationMeta = v.object({
  count: v.nullish(v.pipe(v.number(), v.integer(), v.minValue(0))),
});

/**
 * Device ID
 *
 * A device ID as per https://matrix.org/docs/spec/client_server/r0.6.0#device-ids
 */
export const vDeviceId = v.pipe(
  v.string(),
  v.regex(/^[A-Za-z0-9._~!$&'()*+,;=:&\/-]+$/),
);

/**
 * A compatibility session for legacy clients
 */
export const vCompatSession = v.object({
  user_id: vUlid,
  device_id: v.nullish(vDeviceId),
  user_session_id: v.nullish(vUlid),
  redirect_uri: v.nullish(v.pipe(v.string(), v.url())),
  created_at: v.pipe(v.string(), v.isoTimestamp()),
  user_agent: v.nullish(v.string()),
  last_active_at: v.nullish(v.pipe(v.string(), v.isoTimestamp())),
  last_active_ip: v.nullish(v.string()),
  finished_at: v.nullish(v.pipe(v.string(), v.isoTimestamp())),
  human_name: v.nullish(v.string()),
});

/**
 * Related links
 */
export const vSelfLinks = v.object({
  self: v.string(),
});

/**
 * Pagination metadata for a resource
 */
export const vSingleResourceMetaPage = v.object({
  cursor: v.string(),
});

/**
 * Metadata associated with a resource
 */
export const vSingleResourceMeta = v.object({
  page: v.nullish(vSingleResourceMetaPage),
});

/**
 * A single resource, with its type, ID, attributes and related links
 */
export const vSingleResourceForCompatSession = v.object({
  type: v.string(),
  id: vUlid,
  attributes: vCompatSession,
  links: vSelfLinks,
  meta: v.nullish(vSingleResourceMeta),
});

/**
 * Related links
 */
export const vPaginationLinks = v.object({
  self: v.string(),
  first: v.nullish(v.string()),
  last: v.nullish(v.string()),
  next: v.nullish(v.string()),
  prev: v.nullish(v.string()),
});

/**
 * A top-level response with a page of resources
 */
export const vPaginatedResponseForCompatSession = v.object({
  meta: v.nullish(vPaginationMeta),
  data: v.nullish(v.array(vSingleResourceForCompatSession)),
  links: vPaginationLinks,
});

/**
 * A single error
 */
export const vError = v.object({
  title: v.string(),
});

/**
 * A top-level response with a list of errors
 */
export const vErrorResponse = v.object({
  errors: v.array(vError),
});

export const vUlidInPath = v.object({
  id: vUlid,
});

/**
 * A top-level response with a single resource
 */
export const vSingleResponseForCompatSession = v.object({
  data: vSingleResourceForCompatSession,
  links: vSelfLinks,
});

export const vOAuth2ClientKind = v.picklist(["dynamic", "static"]);

export const vOAuth2ClientFilter = v.object({
  "filter[client-kind]": v.nullish(vOAuth2ClientKind),
  "filter[client-name]": v.nullish(v.string()),
  "filter[client-uri]": v.nullish(v.string()),
  "filter[grant-type]": v.nullish(v.string()),
  "filter[has-active-sessions]": v.nullish(v.boolean()),
});

/**
 * An OAuth 2.0 client registered with this service
 */
export const vOAuth2Client = v.object({
  client_id: v.string(),
  client_name: v.nullish(v.string()),
  client_uri: v.nullish(v.pipe(v.string(), v.url())),
  logo_uri: v.nullish(v.pipe(v.string(), v.url())),
  redirect_uris: v.array(v.pipe(v.string(), v.url())),
  grant_types: v.array(v.string()),
  is_static: v.boolean(),
});

/**
 * A single resource, with its type, ID, attributes and related links
 */
export const vSingleResourceForOAuth2Client = v.object({
  type: v.string(),
  id: vUlid,
  attributes: vOAuth2Client,
  links: vSelfLinks,
  meta: v.nullish(vSingleResourceMeta),
});

/**
 * A top-level response with a page of resources
 */
export const vPaginatedResponseForOAuth2Client = v.object({
  meta: v.nullish(vPaginationMeta),
  data: v.nullish(v.array(vSingleResourceForOAuth2Client)),
  links: vPaginationLinks,
});

/**
 * A top-level response with a single resource
 */
export const vSingleResponseForOAuth2Client = v.object({
  data: vSingleResourceForOAuth2Client,
  links: vSelfLinks,
});

export const vOAuth2ClientKind2 = v.picklist(["dynamic", "static"]);

export const vOAuth2SessionStatus = v.picklist(["active", "finished"]);

export const vOAuth2SessionFilter = v.object({
  "filter[user]": v.nullish(vUlid),
  "filter[client]": v.optional(v.array(vUlid), []),
  "filter[client-kind]": v.nullish(vOAuth2ClientKind2),
  "filter[user-session]": v.nullish(vUlid),
  "filter[scope]": v.optional(v.array(v.string()), []),
  "filter[status]": v.nullish(vOAuth2SessionStatus),
  "filter[created-before]": v.nullish(v.pipe(v.string(), v.isoTimestamp())),
  "filter[created-after]": v.nullish(v.pipe(v.string(), v.isoTimestamp())),
  "filter[last-active-before]": v.nullish(v.pipe(v.string(), v.isoTimestamp())),
  "filter[last-active-after]": v.nullish(v.pipe(v.string(), v.isoTimestamp())),
});

/**
 * A OAuth 2.0 session
 */
export const vOAuth2Session = v.object({
  created_at: v.pipe(v.string(), v.isoTimestamp()),
  finished_at: v.nullish(v.pipe(v.string(), v.isoTimestamp())),
  user_id: v.nullish(vUlid),
  user_session_id: v.nullish(vUlid),
  client_id: vUlid,
  scope: v.string(),
  user_agent: v.nullish(v.string()),
  last_active_at: v.nullish(v.pipe(v.string(), v.isoTimestamp())),
  last_active_ip: v.nullish(v.string()),
  human_name: v.nullish(v.string()),
});

/**
 * A single resource, with its type, ID, attributes and related links
 */
export const vSingleResourceForOAuth2Session = v.object({
  type: v.string(),
  id: vUlid,
  attributes: vOAuth2Session,
  links: vSelfLinks,
  meta: v.nullish(vSingleResourceMeta),
});

/**
 * A top-level response with a page of resources
 */
export const vPaginatedResponseForOAuth2Session = v.object({
  meta: v.nullish(vPaginationMeta),
  data: v.nullish(v.array(vSingleResourceForOAuth2Session)),
  links: vPaginationLinks,
});

/**
 * A top-level response with a single resource
 */
export const vSingleResponseForOAuth2Session = v.object({
  data: vSingleResourceForOAuth2Session,
  links: vSelfLinks,
});

export const vPersonalSessionStatus = v.picklist(["active", "revoked"]);

export const vPersonalSessionFilter = v.object({
  "filter[owner_user]": v.nullish(vUlid),
  "filter[owner_client]": v.nullish(vUlid),
  "filter[actor_user]": v.nullish(vUlid),
  "filter[scope]": v.optional(v.array(v.string()), []),
  "filter[status]": v.nullish(vPersonalSessionStatus),
  "filter[expires_before]": v.nullish(v.pipe(v.string(), v.isoTimestamp())),
  "filter[expires_after]": v.nullish(v.pipe(v.string(), v.isoTimestamp())),
  "filter[expires]": v.nullish(v.boolean()),
});

/**
 * A personal session (session using personal access tokens)
 */
export const vPersonalSession = v.object({
  created_at: v.pipe(v.string(), v.isoTimestamp()),
  revoked_at: v.nullish(v.pipe(v.string(), v.isoTimestamp())),
  owner_user_id: v.nullish(vUlid),
  owner_client_id: v.nullish(vUlid),
  actor_user_id: vUlid,
  human_name: v.string(),
  scope: v.string(),
  last_active_at: v.nullish(v.pipe(v.string(), v.isoTimestamp())),
  last_active_ip: v.nullish(v.string()),
  expires_at: v.nullish(v.pipe(v.string(), v.isoTimestamp())),
  access_token: v.nullish(v.string()),
});

/**
 * A single resource, with its type, ID, attributes and related links
 */
export const vSingleResourceForPersonalSession = v.object({
  type: v.string(),
  id: vUlid,
  attributes: vPersonalSession,
  links: vSelfLinks,
  meta: v.nullish(vSingleResourceMeta),
});

/**
 * A top-level response with a page of resources
 */
export const vPaginatedResponseForPersonalSession = v.object({
  meta: v.nullish(vPaginationMeta),
  data: v.nullish(v.array(vSingleResourceForPersonalSession)),
  links: vPaginationLinks,
});

/**
 * JSON payload for the `POST /api/admin/v1/personal-sessions` endpoint
 */
export const vCreatePersonalSessionRequest = v.object({
  actor_user_id: vUlid,
  human_name: v.string(),
  scope: v.string(),
  expires_in: v.nullish(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(0),
      v.maxValue(
        4294967295,
        "Invalid value: Expected uint32 to be <= 4294967295",
      ),
    ),
  ),
});

/**
 * A top-level response with a single resource
 */
export const vSingleResponseForPersonalSession = v.object({
  data: vSingleResourceForPersonalSession,
  links: vSelfLinks,
});

/**
 * JSON payload for the `POST /api/admin/v1/personal-sessions/{id}/regenerate` endpoint
 */
export const vRegeneratePersonalSessionRequest = v.object({
  expires_in: v.nullish(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(0),
      v.maxValue(
        4294967295,
        "Invalid value: Expected uint32 to be <= 4294967295",
      ),
    ),
  ),
});

/**
 * JSON payload for the `POST /api/admin/v1/policy-data`
 */
export const vSetPolicyDataRequest = v.object({
  data: v.unknown(),
});

/**
 * The policy data
 */
export const vPolicyData = v.object({
  created_at: v.pipe(v.string(), v.isoTimestamp()),
  data: v.unknown(),
});

/**
 * A single resource, with its type, ID, attributes and related links
 */
export const vSingleResourceForPolicyData = v.object({
  type: v.string(),
  id: vUlid,
  attributes: vPolicyData,
  links: vSelfLinks,
  meta: v.nullish(vSingleResourceMeta),
});

/**
 * A top-level response with a single resource
 */
export const vSingleResponseForPolicyData = v.object({
  data: vSingleResourceForPolicyData,
  links: vSelfLinks,
});

export const vUserStatus = v.picklist(["active", "locked", "deactivated"]);

export const vUserFilter = v.object({
  "filter[admin]": v.nullish(v.boolean()),
  "filter[legacy-guest]": v.nullish(v.boolean()),
  "filter[search]": v.nullish(v.string()),
  "filter[status]": v.nullish(vUserStatus),
  "filter[active-oauth2-client]": v.optional(v.array(vUlid), []),
  "filter[has-active-oauth2-session]": v.nullish(v.boolean()),
  "filter[has-active-compat-session]": v.nullish(v.boolean()),
});

/**
 * A user
 */
export const vUser = v.object({
  username: v.string(),
  created_at: v.pipe(v.string(), v.isoTimestamp()),
  locked_at: v.nullish(v.pipe(v.string(), v.isoTimestamp())),
  deactivated_at: v.nullish(v.pipe(v.string(), v.isoTimestamp())),
  admin: v.boolean(),
  legacy_guest: v.optional(v.boolean()),
});

/**
 * A single resource, with its type, ID, attributes and related links
 */
export const vSingleResourceForUser = v.object({
  type: v.string(),
  id: vUlid,
  attributes: vUser,
  links: vSelfLinks,
  meta: v.nullish(vSingleResourceMeta),
});

/**
 * A top-level response with a page of resources
 */
export const vPaginatedResponseForUser = v.object({
  meta: v.nullish(vPaginationMeta),
  data: v.nullish(v.array(vSingleResourceForUser)),
  links: vPaginationLinks,
});

/**
 * JSON payload for the `POST /api/admin/v1/users` endpoint
 */
export const vAddUserRequest = v.object({
  username: v.string(),
  skip_homeserver_check: v.optional(v.boolean(), false),
  displayname: v.nullish(v.string()),
  avatar_url: v.nullish(v.string()),
});

/**
 * A top-level response with a single resource
 */
export const vSingleResponseForUser = v.object({
  data: vSingleResourceForUser,
  links: vSelfLinks,
});

/**
 * JSON payload for the `POST /api/admin/v1/users/:id/set-password` endpoint
 */
export const vSetUserPasswordRequest = v.object({
  password: v.string(),
  skip_password_check: v.nullish(v.boolean()),
});

export const vUsernamePathParam = v.object({
  username: v.string(),
});

/**
 * JSON payload for the `POST /api/admin/v1/users/:id/set-admin` endpoint
 */
export const vUserSetAdminRequest = v.object({
  admin: v.boolean(),
});

/**
 * JSON payload for the `POST /api/admin/v1/users/:id/deactivate` endpoint
 */
export const vDeactivateUserRequest = v.object({
  skip_erase: v.optional(v.boolean(), false),
});

export const vUserEmailFilter = v.object({
  "filter[user]": v.nullish(vUlid),
  "filter[email]": v.nullish(v.string()),
});

/**
 * An email address for a user
 */
export const vUserEmail = v.object({
  created_at: v.pipe(v.string(), v.isoTimestamp()),
  user_id: vUlid,
  email: v.string(),
});

/**
 * A single resource, with its type, ID, attributes and related links
 */
export const vSingleResourceForUserEmail = v.object({
  type: v.string(),
  id: vUlid,
  attributes: vUserEmail,
  links: vSelfLinks,
  meta: v.nullish(vSingleResourceMeta),
});

/**
 * A top-level response with a page of resources
 */
export const vPaginatedResponseForUserEmail = v.object({
  meta: v.nullish(vPaginationMeta),
  data: v.nullish(v.array(vSingleResourceForUserEmail)),
  links: vPaginationLinks,
});

/**
 * JSON payload for the `POST /api/admin/v1/user-emails`
 */
export const vAddUserEmailRequest = v.object({
  user_id: vUlid,
  email: v.pipe(v.string(), v.email()),
});

/**
 * A top-level response with a single resource
 */
export const vSingleResponseForUserEmail = v.object({
  data: vSingleResourceForUserEmail,
  links: vSelfLinks,
});

export const vUserSessionStatus = v.picklist(["active", "finished"]);

export const vUserSessionFilter = v.object({
  "filter[user]": v.nullish(vUlid),
  "filter[status]": v.nullish(vUserSessionStatus),
  "filter[created-before]": v.nullish(v.pipe(v.string(), v.isoTimestamp())),
  "filter[created-after]": v.nullish(v.pipe(v.string(), v.isoTimestamp())),
  "filter[last-active-before]": v.nullish(v.pipe(v.string(), v.isoTimestamp())),
  "filter[last-active-after]": v.nullish(v.pipe(v.string(), v.isoTimestamp())),
});

/**
 * The browser (cookie) session for a user
 */
export const vUserSession = v.object({
  created_at: v.pipe(v.string(), v.isoTimestamp()),
  finished_at: v.nullish(v.pipe(v.string(), v.isoTimestamp())),
  user_id: vUlid,
  user_agent: v.nullish(v.string()),
  last_active_at: v.nullish(v.pipe(v.string(), v.isoTimestamp())),
  last_active_ip: v.nullish(v.string()),
});

/**
 * A single resource, with its type, ID, attributes and related links
 */
export const vSingleResourceForUserSession = v.object({
  type: v.string(),
  id: vUlid,
  attributes: vUserSession,
  links: vSelfLinks,
  meta: v.nullish(vSingleResourceMeta),
});

/**
 * A top-level response with a page of resources
 */
export const vPaginatedResponseForUserSession = v.object({
  meta: v.nullish(vPaginationMeta),
  data: v.nullish(v.array(vSingleResourceForUserSession)),
  links: vPaginationLinks,
});

/**
 * A top-level response with a single resource
 */
export const vSingleResponseForUserSession = v.object({
  data: vSingleResourceForUserSession,
  links: vSelfLinks,
});

export const vRegistrationTokenFilter = v.object({
  "filter[used]": v.nullish(v.boolean()),
  "filter[revoked]": v.nullish(v.boolean()),
  "filter[expired]": v.nullish(v.boolean()),
  "filter[valid]": v.nullish(v.boolean()),
});

/**
 * A registration token
 */
export const vUserRegistrationToken = v.object({
  token: v.string(),
  valid: v.boolean(),
  usage_limit: v.nullish(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(0),
      v.maxValue(
        4294967295,
        "Invalid value: Expected uint32 to be <= 4294967295",
      ),
    ),
  ),
  times_used: v.pipe(
    v.number(),
    v.integer(),
    v.minValue(0),
    v.maxValue(
      4294967295,
      "Invalid value: Expected uint32 to be <= 4294967295",
    ),
  ),
  created_at: v.pipe(v.string(), v.isoTimestamp()),
  last_used_at: v.nullish(v.pipe(v.string(), v.isoTimestamp())),
  expires_at: v.nullish(v.pipe(v.string(), v.isoTimestamp())),
  revoked_at: v.nullish(v.pipe(v.string(), v.isoTimestamp())),
});

/**
 * A single resource, with its type, ID, attributes and related links
 */
export const vSingleResourceForUserRegistrationToken = v.object({
  type: v.string(),
  id: vUlid,
  attributes: vUserRegistrationToken,
  links: vSelfLinks,
  meta: v.nullish(vSingleResourceMeta),
});

/**
 * A top-level response with a page of resources
 */
export const vPaginatedResponseForUserRegistrationToken = v.object({
  meta: v.nullish(vPaginationMeta),
  data: v.nullish(v.array(vSingleResourceForUserRegistrationToken)),
  links: vPaginationLinks,
});

/**
 * JSON payload for the `POST /api/admin/v1/user-registration-tokens`
 */
export const vAddUserRegistrationTokenRequest = v.object({
  token: v.nullish(v.string()),
  usage_limit: v.nullish(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(0),
      v.maxValue(
        4294967295,
        "Invalid value: Expected uint32 to be <= 4294967295",
      ),
    ),
  ),
  expires_at: v.nullish(v.pipe(v.string(), v.isoTimestamp())),
});

/**
 * A top-level response with a single resource
 */
export const vSingleResponseForUserRegistrationToken = v.object({
  data: vSingleResourceForUserRegistrationToken,
  links: vSelfLinks,
});

/**
 * JSON payload for the `PUT /api/admin/v1/user-registration-tokens/{id}` endpoint
 */
export const vEditUserRegistrationTokenRequest = v.object({
  expires_at: v.nullish(v.pipe(v.string(), v.isoTimestamp())),
  usage_limit: v.nullish(
    v.pipe(
      v.number(),
      v.integer(),
      v.minValue(0),
      v.maxValue(
        4294967295,
        "Invalid value: Expected uint32 to be <= 4294967295",
      ),
    ),
  ),
});

export const vUpstreamOAuthLinkFilter = v.object({
  "filter[user]": v.nullish(vUlid),
  "filter[provider]": v.nullish(vUlid),
  "filter[subject]": v.nullish(v.string()),
  "filter[human-account-name]": v.nullish(v.string()),
});

/**
 * An upstream OAuth 2.0 link
 */
export const vUpstreamOAuthLink = v.object({
  created_at: v.pipe(v.string(), v.isoTimestamp()),
  provider_id: vUlid,
  subject: v.string(),
  user_id: v.nullish(vUlid),
  human_account_name: v.nullish(v.string()),
});

/**
 * A single resource, with its type, ID, attributes and related links
 */
export const vSingleResourceForUpstreamOAuthLink = v.object({
  type: v.string(),
  id: vUlid,
  attributes: vUpstreamOAuthLink,
  links: vSelfLinks,
  meta: v.nullish(vSingleResourceMeta),
});

/**
 * A top-level response with a page of resources
 */
export const vPaginatedResponseForUpstreamOAuthLink = v.object({
  meta: v.nullish(vPaginationMeta),
  data: v.nullish(v.array(vSingleResourceForUpstreamOAuthLink)),
  links: vPaginationLinks,
});

/**
 * JSON payload for the `POST /api/admin/v1/upstream-oauth-links`
 */
export const vAddUpstreamOauthLinkRequest = v.object({
  user_id: vUlid,
  provider_id: vUlid,
  subject: v.string(),
  human_account_name: v.nullish(v.string()),
});

/**
 * A top-level response with a single resource
 */
export const vSingleResponseForUpstreamOAuthLink = v.object({
  data: vSingleResourceForUpstreamOAuthLink,
  links: vSelfLinks,
});

export const vUpstreamOAuthProviderFilter = v.object({
  "filter[enabled]": v.nullish(v.boolean()),
});

/**
 * An upstream OAuth 2.0 provider
 */
export const vUpstreamOAuthProvider = v.object({
  issuer: v.nullish(v.string()),
  human_name: v.nullish(v.string()),
  brand_name: v.nullish(v.string()),
  created_at: v.pipe(v.string(), v.isoTimestamp()),
  disabled_at: v.nullish(v.pipe(v.string(), v.isoTimestamp())),
  registration_token_required: v.boolean(),
});

/**
 * A single resource, with its type, ID, attributes and related links
 */
export const vSingleResourceForUpstreamOAuthProvider = v.object({
  type: v.string(),
  id: vUlid,
  attributes: vUpstreamOAuthProvider,
  links: vSelfLinks,
  meta: v.nullish(vSingleResourceMeta),
});

/**
 * A top-level response with a page of resources
 */
export const vPaginatedResponseForUpstreamOAuthProvider = v.object({
  meta: v.nullish(vPaginationMeta),
  data: v.nullish(v.array(vSingleResourceForUpstreamOAuthProvider)),
  links: vPaginationLinks,
});

/**
 * A top-level response with a single resource
 */
export const vSingleResponseForUpstreamOAuthProvider = v.object({
  data: vSingleResourceForUpstreamOAuthProvider,
  links: vSelfLinks,
});

export const vSiteConfigResponse = vSiteConfig;

export const vVersionResponse = vVersion;

export const vListCompatSessionsQuery = v.object({
  "page[before]": v.optional(vUlid),
  "page[after]": v.optional(vUlid),
  "page[first]": v.optional(v.pipe(v.number(), v.integer(), v.minValue(1))),
  "page[last]": v.optional(v.pipe(v.number(), v.integer(), v.minValue(1))),
  count: v.optional(vIncludeCount),
  "filter[user]": v.optional(vUlid),
  "filter[user-session]": v.optional(vUlid),
  "filter[status]": v.optional(vCompatSessionStatus),
  "filter[created-before]": v.optional(v.pipe(v.string(), v.isoTimestamp())),
  "filter[created-after]": v.optional(v.pipe(v.string(), v.isoTimestamp())),
  "filter[last-active-before]": v.optional(
    v.pipe(v.string(), v.isoTimestamp()),
  ),
  "filter[last-active-after]": v.optional(v.pipe(v.string(), v.isoTimestamp())),
});

/**
 * Paginated response of compatibility sessions
 */
export const vListCompatSessionsResponse = vPaginatedResponseForCompatSession;

export const vGetCompatSessionPath = v.object({
  id: vUlid,
});

/**
 * Compatibility session was found
 */
export const vGetCompatSessionResponse = vSingleResponseForCompatSession;

export const vFinishCompatSessionPath = v.object({
  id: vUlid,
});

/**
 * Compatibility session was finished
 */
export const vFinishCompatSessionResponse = vSingleResponseForCompatSession;

export const vListOAuth2ClientsQuery = v.object({
  "page[before]": v.optional(vUlid),
  "page[after]": v.optional(vUlid),
  "page[first]": v.optional(v.pipe(v.number(), v.integer(), v.minValue(1))),
  "page[last]": v.optional(v.pipe(v.number(), v.integer(), v.minValue(1))),
  count: v.optional(vIncludeCount),
  "filter[client-kind]": v.optional(vOAuth2ClientKind),
  "filter[client-name]": v.optional(v.string()),
  "filter[client-uri]": v.optional(v.string()),
  "filter[grant-type]": v.optional(v.string()),
  "filter[has-active-sessions]": v.optional(v.boolean()),
});

/**
 * Paginated response of OAuth 2.0 clients
 */
export const vListOAuth2ClientsResponse = vPaginatedResponseForOAuth2Client;

export const vGetOAuth2ClientPath = v.object({
  id: vUlid,
});

/**
 * OAuth 2.0 client was found
 */
export const vGetOAuth2ClientResponse = vSingleResponseForOAuth2Client;

export const vListOAuth2SessionsQuery = v.object({
  "page[before]": v.optional(vUlid),
  "page[after]": v.optional(vUlid),
  "page[first]": v.optional(v.pipe(v.number(), v.integer(), v.minValue(1))),
  "page[last]": v.optional(v.pipe(v.number(), v.integer(), v.minValue(1))),
  count: v.optional(vIncludeCount),
  "filter[user]": v.optional(vUlid),
  "filter[client]": v.optional(v.array(vUlid), []),
  "filter[client-kind]": v.optional(vOAuth2ClientKind2),
  "filter[user-session]": v.optional(vUlid),
  "filter[scope]": v.optional(v.array(v.string()), []),
  "filter[status]": v.optional(vOAuth2SessionStatus),
  "filter[created-before]": v.optional(v.pipe(v.string(), v.isoTimestamp())),
  "filter[created-after]": v.optional(v.pipe(v.string(), v.isoTimestamp())),
  "filter[last-active-before]": v.optional(
    v.pipe(v.string(), v.isoTimestamp()),
  ),
  "filter[last-active-after]": v.optional(v.pipe(v.string(), v.isoTimestamp())),
});

/**
 * Paginated response of OAuth 2.0 sessions
 */
export const vListOAuth2SessionsResponse = vPaginatedResponseForOAuth2Session;

export const vGetOAuth2SessionPath = v.object({
  id: vUlid,
});

/**
 * OAuth 2.0 session was found
 */
export const vGetOAuth2SessionResponse = vSingleResponseForOAuth2Session;

export const vFinishOAuth2SessionPath = v.object({
  id: vUlid,
});

/**
 * OAuth 2.0 session was finished
 */
export const vFinishOAuth2SessionResponse = vSingleResponseForOAuth2Session;

export const vListPersonalSessionsQuery = v.object({
  "page[before]": v.optional(vUlid),
  "page[after]": v.optional(vUlid),
  "page[first]": v.optional(v.pipe(v.number(), v.integer(), v.minValue(1))),
  "page[last]": v.optional(v.pipe(v.number(), v.integer(), v.minValue(1))),
  count: v.optional(vIncludeCount),
  "filter[owner_user]": v.optional(vUlid),
  "filter[owner_client]": v.optional(vUlid),
  "filter[actor_user]": v.optional(vUlid),
  "filter[scope]": v.optional(v.array(v.string()), []),
  "filter[status]": v.optional(vPersonalSessionStatus),
  "filter[expires_before]": v.optional(v.pipe(v.string(), v.isoTimestamp())),
  "filter[expires_after]": v.optional(v.pipe(v.string(), v.isoTimestamp())),
  "filter[expires]": v.optional(v.boolean()),
});

/**
 * Paginated response of personal sessions
 */
export const vListPersonalSessionsResponse =
  vPaginatedResponseForPersonalSession;

export const vCreatePersonalSessionBody = vCreatePersonalSessionRequest;

/**
 * Personal session and personal access token were created
 */
export const vCreatePersonalSessionResponse = vSingleResponseForPersonalSession;

export const vGetPersonalSessionPath = v.object({
  id: vUlid,
});

/**
 * Personal session details
 */
export const vGetPersonalSessionResponse = vSingleResponseForPersonalSession;

export const vRevokePersonalSessionPath = v.object({
  id: vUlid,
});

/**
 * Personal session was revoked
 */
export const vRevokePersonalSessionResponse = vSingleResponseForPersonalSession;

export const vRegeneratePersonalSessionBody = vRegeneratePersonalSessionRequest;

export const vRegeneratePersonalSessionPath = v.object({
  id: vUlid,
});

/**
 * Personal session was regenerated and a personal access token was created
 */
export const vRegeneratePersonalSessionResponse =
  vSingleResponseForPersonalSession;

export const vSetPolicyDataBody = vSetPolicyDataRequest;

/**
 * Policy data was successfully set
 */
export const vSetPolicyDataResponse = vSingleResponseForPolicyData;

/**
 * Latest policy data was found
 */
export const vGetLatestPolicyDataResponse = vSingleResponseForPolicyData;

export const vGetPolicyDataPath = v.object({
  id: vUlid,
});

/**
 * Policy data was found
 */
export const vGetPolicyDataResponse = vSingleResponseForPolicyData;

export const vListUsersQuery = v.object({
  "page[before]": v.optional(vUlid),
  "page[after]": v.optional(vUlid),
  "page[first]": v.optional(v.pipe(v.number(), v.integer(), v.minValue(1))),
  "page[last]": v.optional(v.pipe(v.number(), v.integer(), v.minValue(1))),
  count: v.optional(vIncludeCount),
  "filter[admin]": v.optional(v.boolean()),
  "filter[legacy-guest]": v.optional(v.boolean()),
  "filter[search]": v.optional(v.string()),
  "filter[status]": v.optional(vUserStatus),
  "filter[active-oauth2-client]": v.optional(v.array(vUlid), []),
  "filter[has-active-oauth2-session]": v.optional(v.boolean()),
  "filter[has-active-compat-session]": v.optional(v.boolean()),
});

/**
 * Paginated response of users
 */
export const vListUsersResponse = vPaginatedResponseForUser;

export const vCreateUserBody = vAddUserRequest;

/**
 * User was created
 */
export const vCreateUserResponse = vSingleResponseForUser;

export const vGetUserPath = v.object({
  id: vUlid,
});

/**
 * User was found
 */
export const vGetUserResponse = vSingleResponseForUser;

export const vSetUserPasswordBody = vSetUserPasswordRequest;

export const vSetUserPasswordPath = v.object({
  id: vUlid,
});

/**
 * Password was set
 */
export const vSetUserPasswordResponse = v.void();

export const vGetUserByUsernamePath = v.object({
  username: v.string(),
});

/**
 * User was found
 */
export const vGetUserByUsernameResponse = vSingleResponseForUser;

export const vUserSetAdminBody = vUserSetAdminRequest;

export const vUserSetAdminPath = v.object({
  id: vUlid,
});

/**
 * User had admin privileges set
 */
export const vUserSetAdminResponse = vSingleResponseForUser;

export const vDeactivateUserBody = vDeactivateUserRequest;

export const vDeactivateUserPath = v.object({
  id: vUlid,
});

/**
 * User was deactivated
 */
export const vDeactivateUserResponse = vSingleResponseForUser;

export const vReactivateUserPath = v.object({
  id: vUlid,
});

/**
 * User was reactivated
 */
export const vReactivateUserResponse = vSingleResponseForUser;

export const vLockUserPath = v.object({
  id: vUlid,
});

/**
 * User was locked
 */
export const vLockUserResponse = vSingleResponseForUser;

export const vUnlockUserPath = v.object({
  id: vUlid,
});

/**
 * User was unlocked
 */
export const vUnlockUserResponse = vSingleResponseForUser;

export const vListUserEmailsQuery = v.object({
  "page[before]": v.optional(vUlid),
  "page[after]": v.optional(vUlid),
  "page[first]": v.optional(v.pipe(v.number(), v.integer(), v.minValue(1))),
  "page[last]": v.optional(v.pipe(v.number(), v.integer(), v.minValue(1))),
  count: v.optional(vIncludeCount),
  "filter[user]": v.optional(vUlid),
  "filter[email]": v.optional(v.string()),
});

/**
 * Paginated response of user emails
 */
export const vListUserEmailsResponse = vPaginatedResponseForUserEmail;

export const vAddUserEmailBody = vAddUserEmailRequest;

/**
 * User email was created
 */
export const vAddUserEmailResponse = vSingleResponseForUserEmail;

export const vDeleteUserEmailPath = v.object({
  id: vUlid,
});

/**
 * User email was found
 */
export const vDeleteUserEmailResponse = v.void();

export const vGetUserEmailPath = v.object({
  id: vUlid,
});

/**
 * User email was found
 */
export const vGetUserEmailResponse = vSingleResponseForUserEmail;

export const vListUserSessionsQuery = v.object({
  "page[before]": v.optional(vUlid),
  "page[after]": v.optional(vUlid),
  "page[first]": v.optional(v.pipe(v.number(), v.integer(), v.minValue(1))),
  "page[last]": v.optional(v.pipe(v.number(), v.integer(), v.minValue(1))),
  count: v.optional(vIncludeCount),
  "filter[user]": v.optional(vUlid),
  "filter[status]": v.optional(vUserSessionStatus),
  "filter[created-before]": v.optional(v.pipe(v.string(), v.isoTimestamp())),
  "filter[created-after]": v.optional(v.pipe(v.string(), v.isoTimestamp())),
  "filter[last-active-before]": v.optional(
    v.pipe(v.string(), v.isoTimestamp()),
  ),
  "filter[last-active-after]": v.optional(v.pipe(v.string(), v.isoTimestamp())),
});

/**
 * Paginated response of user sessions
 */
export const vListUserSessionsResponse = vPaginatedResponseForUserSession;

export const vGetUserSessionPath = v.object({
  id: vUlid,
});

/**
 * User session was found
 */
export const vGetUserSessionResponse = vSingleResponseForUserSession;

export const vFinishUserSessionPath = v.object({
  id: vUlid,
});

/**
 * User session was finished
 */
export const vFinishUserSessionResponse = vSingleResponseForUserSession;

export const vListUserRegistrationTokensQuery = v.object({
  "page[before]": v.optional(vUlid),
  "page[after]": v.optional(vUlid),
  "page[first]": v.optional(v.pipe(v.number(), v.integer(), v.minValue(1))),
  "page[last]": v.optional(v.pipe(v.number(), v.integer(), v.minValue(1))),
  count: v.optional(vIncludeCount),
  "filter[used]": v.optional(v.boolean()),
  "filter[revoked]": v.optional(v.boolean()),
  "filter[expired]": v.optional(v.boolean()),
  "filter[valid]": v.optional(v.boolean()),
});

/**
 * Paginated response of registration tokens
 */
export const vListUserRegistrationTokensResponse =
  vPaginatedResponseForUserRegistrationToken;

export const vAddUserRegistrationTokenBody = vAddUserRegistrationTokenRequest;

/**
 * A new user registration token was created
 */
export const vAddUserRegistrationTokenResponse =
  vSingleResponseForUserRegistrationToken;

export const vGetUserRegistrationTokenPath = v.object({
  id: vUlid,
});

/**
 * Registration token was found
 */
export const vGetUserRegistrationTokenResponse =
  vSingleResponseForUserRegistrationToken;

export const vUpdateUserRegistrationTokenBody =
  vEditUserRegistrationTokenRequest;

export const vUpdateUserRegistrationTokenPath = v.object({
  id: vUlid,
});

/**
 * Registration token was updated
 */
export const vUpdateUserRegistrationTokenResponse =
  vSingleResponseForUserRegistrationToken;

export const vRevokeUserRegistrationTokenPath = v.object({
  id: vUlid,
});

/**
 * Registration token was revoked
 */
export const vRevokeUserRegistrationTokenResponse =
  vSingleResponseForUserRegistrationToken;

export const vUnrevokeUserRegistrationTokenPath = v.object({
  id: vUlid,
});

/**
 * Registration token was unrevoked
 */
export const vUnrevokeUserRegistrationTokenResponse =
  vSingleResponseForUserRegistrationToken;

export const vListUpstreamOAuthLinksQuery = v.object({
  "page[before]": v.optional(vUlid),
  "page[after]": v.optional(vUlid),
  "page[first]": v.optional(v.pipe(v.number(), v.integer(), v.minValue(1))),
  "page[last]": v.optional(v.pipe(v.number(), v.integer(), v.minValue(1))),
  count: v.optional(vIncludeCount),
  "filter[user]": v.optional(vUlid),
  "filter[provider]": v.optional(vUlid),
  "filter[subject]": v.optional(v.string()),
  "filter[human-account-name]": v.optional(v.string()),
});

/**
 * Paginated response of upstream OAuth 2.0 links
 */
export const vListUpstreamOAuthLinksResponse =
  vPaginatedResponseForUpstreamOAuthLink;

export const vAddUpstreamOAuthLinkBody = vAddUpstreamOauthLinkRequest;

/**
 * An existing Upstream OAuth 2.0 link was associated to a user
 */
export const vAddUpstreamOAuthLinkResponse =
  vSingleResponseForUpstreamOAuthLink;

export const vDeleteUpstreamOAuthLinkPath = v.object({
  id: vUlid,
});

/**
 * Upstream OAuth 2.0 link was deleted
 */
export const vDeleteUpstreamOAuthLinkResponse = v.void();

export const vGetUpstreamOAuthLinkPath = v.object({
  id: vUlid,
});

/**
 * Upstream OAuth 2.0 link was found
 */
export const vGetUpstreamOAuthLinkResponse =
  vSingleResponseForUpstreamOAuthLink;

export const vListUpstreamOAuthProvidersQuery = v.object({
  "page[before]": v.optional(vUlid),
  "page[after]": v.optional(vUlid),
  "page[first]": v.optional(v.pipe(v.number(), v.integer(), v.minValue(1))),
  "page[last]": v.optional(v.pipe(v.number(), v.integer(), v.minValue(1))),
  count: v.optional(vIncludeCount),
  "filter[enabled]": v.optional(v.boolean()),
});

/**
 * Paginated response of upstream OAuth 2.0 providers
 */
export const vListUpstreamOAuthProvidersResponse =
  vPaginatedResponseForUpstreamOAuthProvider;

export const vGetUpstreamOAuthProviderPath = v.object({
  id: vUlid,
});

/**
 * The upstream OAuth provider
 */
export const vGetUpstreamOAuthProviderResponse =
  vSingleResponseForUpstreamOAuthProvider;
